jQuery(document).ready(function ($) {


	const DEV = 0

	const form = $('#yoga_mailing_form');

	DEV && log('mailing_list_nonce', mailing_list_nonce)


	$(form).on('submit', function(e) {
        e.preventDefault();
        
        var email_input = $(form).find('input[type="email"]')
        var email = $(email_input).val();
        var messageDiv = $(form).parent('div').find('.message');
        var submitButton = $(form).find('button[type="submit"]');
        
        // Disable button during request
        submitButton.prop('disabled', true);
        
        $.ajax({
            url: appInfo.ajax_url,
            type: 'POST',
            data: {
                action: 'subscribe_mailing_list',
                email: email,
                nonce: mailing_list_nonce
            },
            success: function(response) {
            	DEV && log('success', response)
                if (response.success) {
                    messageDiv
                        .removeClass('error')
                        .addClass('success')
                        .text(response.data.message)
                        .fadeIn();
                    
                    // Clear the form
                    email_input.val('');
                } else {
                    messageDiv
                        .removeClass('success')
                        .addClass('error')
                        .text(response.data.message)
                        .fadeIn();
                }
                
                // Re-enable button
                submitButton.prop('disabled', false);
                
                // Hide message after 5 seconds
                setTimeout(function() {
                    messageDiv.fadeOut();
                    email_input.val('');
                }, 3000);
            },
            error: function(error) {
            	DEV && log('error', error)
                messageDiv
                    .removeClass('success')
                    .addClass('error')
                    .text('An error occurred. Please try again.')
                    .fadeIn();
                
                submitButton.prop('disabled', false);
            }
        });
    });
})